import { render, staticRenderFns } from "./RecallHome.vue?vue&type=template&id=33c3a331&scoped=true&"
import script from "./RecallHome.vue?vue&type=script&lang=js&"
export * from "./RecallHome.vue?vue&type=script&lang=js&"
import style0 from "./RecallHome.vue?vue&type=style&index=0&id=33c3a331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3a331",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
